<template>
  <!--商品详情-->
<div>
  <div id="product-detail" v-if="keydata.cupType">
    <!--图片-->
    <div class="main-img">
      <img :src='beverage.picture.path' width="320" height="320">
    </div>
    <!--文字-->
    <div class="img-content">
      <div class="img-content-title">
        <a href="#">{{beverage.name}} {{cuptype.cupSize==null?'':cuptype.cupSize.name}}</a>
      </div>
      <div class="price" v-if="!isFree">
        <span class="ng-binding">¥ {{beveragePrice}}</span>
      </div>
    </div>
    <div class="bottom-nopay" v-if="wxAppId=='a'&&isWx" >{{isFree||beveragePrice==0?'立即打杯':'立即支付'}}</div>
    <div class="bottom-pay" v-if="wxAppId!='a'||isAlipay" @click="payNow">{{isFree||beveragePrice==0?'立即打杯':'立即支付'}}</div>
  </div>
  <div id="product-detail" v-else>
    <!--图片-->
    <div class="main-img">
      <img :src='keydata.fileLib.path' width="320" height="320" v-if="keydata.fileLib">
      <img :src="defaultPicPath" width="320" height="320" v-else>
    </div>
    <!--文字-->
    <div class="img-content">
      <div class="img-content-title">
        <a href="#">{{keydata.name}}</a>
      </div>
      <div class="price" v-if="!isFree">
        <span class="ng-binding">¥ {{keydata.price}}</span>
      </div>
    </div>
    <div class="bottom-pay" @click="payNow">{{isFree||beveragePrice==0?'立即打杯':'立即支付'}}</div>
  </div>
</div>
</template>

<script>
import {productList,getOpenId,addOrder,wxPay,aliPay,getAppId,produceBeverageByOrder} from "@/api/productApi";
import {jsSDK} from '../api/jsSDK.js'
import {getUrlParam} from "../utils/commonUtil";
import md5 from 'js-md5';
import {GetSignature} from "../api/common";
import wx from 'weixin-js-sdk';
import {checkSource,generateOrderNo} from "../utils/productUtil";

let _this;
export default {
  name: "ProductDetail",
  data(){
    return{
      cupTypeId:0,
      beverageId: '',
      dtuNo: '',
      wxAppId : 'a',
      keyConfigId: '',//按键id
      price:0,//订单价格
      beverage:{
        picture:{
          path:'../../assets/logo.png'
        }
      },
      defaultPicPath:require('../assets/no_pic.png'),
      beveragePrice:0,
      // 订单信息
      order:{},
      orderData:{},
      cuptype:new Object(),
      isWx:true,// 是否是微信支付
      isAlipay:false,
      isFree:false,//是否免费模式
      openId:'',// 将openId作为本地参数储存,
      code:'',
      currentTime:'',
      free:0,
      keydata:[],
      sort:0
    }
  },
  mounted() {
    var element = document.createElement("script");
    element.src = "https://gw.alipayobjects.com/as/g/h5-lib/alipayjsapi/3.1.1/alipayjsapi.inc.min.js";
    document.body.appendChild(element);
    this.free = Number(this.$route.query.free);
    this.sort = Number(this.$route.query.sort);
    this.dtuNo = this.$route.query.dtuNo;
    if(this.free == 1){
      this.isFree = true
    }else{
      this.isFree =false
    }
     _this = this
    this.getWxAuth()
    this.getProductDetail()
  },
  methods:{

    getWxAuth(){
      this.code = getUrlParam('code')
      let source = checkSource();
      // let source = 1;
      if(source == -1){
        alert('非支付宝和微信扫码')
        return
      }else if(source == 1){
        this.isWx = true
        this.isAlipay = false
      }else if(source == 2){
        this.isWx = false
        this.isAlipay = true
      }
    },
    //根据ID获取饮品的详细信息
    getProductDetail(){
      this.$forceUpdate();
      let that = this;
      //有两种可能，参数从router带来或者从url带来，都需要判断
      if(this.$route.query.cupTypeId!=null && this.$route.query.cupTypeId!=undefined && this.$route.query.dtuNo!=null && this.$route.query.dtuNo!=undefined){
        this.cupTypeId = this.$route.query.cupTypeId
        this.dtuNo = this.$route.query.dtuNo
        this.sort =this.$route.query.sort
      }else if(this.$route.params.cupTypeId!=null && this.$route.params.cupTypeId!=undefined && this.$route.params.dtuNo!=null && this.$route.params.dtuNo!=undefined){
        this.cupTypeId = this.$route.params.cupTypeId
        this.dtuNo = this.$route.params.dtuNo
        this.sort =this.$route.params.sort
      }
      if(this.dtuNo){
        productList({dtuNo:this.dtuNo}).then(res=>{
          let tempList = res.data
          tempList.forEach(element=>{
            if((element.cupType&&element.cupType.id == that.cupTypeId)||element.sort == that.sort){
              that.keyConfigId = element.id
              if(that.free=0){
                that.isFree = element.price==0?true:false
              }
              that.order = {
                id:0,
                orderNo:'', // 订单号
                orderStatus:0, // 0,1,2,3不知道什么意思
                remark:'', // 备注
                totalAmount:element.price, // 原价
                actualAmount:element.price,// 扣除优惠券以后的金额
                cupTypeID:element.cupTypeID, // 杯型ID
                keyConfig_ID:element.id,
                dtuNo:that.dtuNo, // free:element.price>0?false:true,
                orderTime:'',
                // title:element.cupType.beverage.name+' '+(element.cupType.cupSize?element.cupType.cupSize.name:'')
                title:res.data.cupType?res.data.cupType.beverage.name+' '+(res.data.cupType.cupSize?res.data.cupType.cupSize.name:''):res.data.name
              }
              that.beveragePrice = element.price;
              if(element.cupType){
                that.cuptype = element.cupType
                that.beverage = element.cupType.beverage;
              }
              that.keydata = element;
              if(this.isWx && !this.isFree){
                getAppId({dtuNo:this.dtuNo}).then(res=>{
                  if(res.code==200){
                    this.wxAppId = res.data.wxAppId;
                    if(!this.openId){
                      // 如果是微信，且openid为空
                      const code = getUrlParam('code')
                      if (code == null || code == '' || code == undefined) {
                        //const url = 'https://icloud.lhcoffeetime.com/pages/payment/index.html?dtuNo='+this.dtuNo+'&sort='+this.sort+'&free='+this.free+'#/productdetail';
                        //window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + this.wxAppId + '&redirect_uri=' + encodeURIComponent(url) + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
                        const url = 'https://icloud.lhcoffeetime.com/pages/payment/#/productdetail?dtuNo='+this.dtuNo+'&sort='+this.sort+'&free='+this.free;
                        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + this.wxAppId + '&redirect_uri=' + encodeURIComponent(url) + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
                      }
                    }
                    return;
                  }else{
                    alert(res.msg);
                    return;
                  }
                });
              }
              that.$forceUpdate();
              return;
            }

          })
        });
      }
    },
    // 立即支付
    payNow(){
      this.reloading = this.openLoading()
        if(this.isFree){
          this.order.free = true
          // this.payMode = 0
          this.order.payMode = 0
        }else{
          this.order.free = false
          if(this.isWx){
            // this.payMode = 1
            this.order.payMode = 1
          }else if(this.isAlipay){
            // this.payMode = 2
            this.order.payMode = 2
          }
        }

        let orderData = {} // 临时对象
        this.getCurrentTime();
        this.order.orderTime = this.currentTime
        this.order.orderForm = 1
        if(this.isFree){
          let orderNo = generateOrderNo()
          this.order.orderNo = orderNo
        }
        // 生成订单
        let that =this;
        addOrder(this.order).then(res=>{
          if(res.code==200){
            //区分是否是免费模式
            if(that.isFree || this.beveragePrice ==0){
              let param = {
                orderNo:res.data.orderNo
              }
              let orderNo = res.data.orderNo;
              let orderForm = res.data.orderForm;
              produceBeverageByOrder(param).then(res=>{
                if(res.code==200){
                  // this.$router.push({name:'Product',params:{dtuNo:this.dtuNo}})
                  window.location.href = 'https://icloud.lhcoffeetime.com/pages/payment/index.html#/cupsuccess?orderNo='+orderNo+'&orderFrom='+orderForm+'&dtuNo='+this.dtuNo

                }
              })
            }else{
              // 区分支付宝还是微信
              if(that.isWx&&!that.isFree){
                orderData.orderNo = res.data.orderNo;
                orderData.total_fee = res.data.actualAmount;
                orderData.body = res.data.cupType?res.data.cupType.beverage.name:'';
                if(that.openId){
                  orderData.openId =  that.openId
                  orderData.apiType = 'JSAPI'
                  wxPay(orderData).then(res=>{
                    //这个对象用来调起支付接口
                    let tempData = {
                      appId: res.data.appid,
                      timeStamp:res.data.timestamp,
                      nonceStr:res.data.noncestr,
                      package:'prepay_id='+res.data.prepayid,
                      signType: 'MD5',
                      paySign:res.data.sign,
                      key:res.data.key,
                      //另外的参数，用于支付结束后获取订单信息
                      orderNo:orderData.orderNo
                    }
                    _this.rechargeWx(tempData)
                  })
                }else{
                  // 获取openid
                  const code = getUrlParam('code')
                  let param = {
                    appId:that.wxAppId,
                    code:code,
                    dtuNo:that.dtuNo
                  }
                  getOpenId(param).then(res=>{
                    orderData.openId = res.data.wxOpenId
                    that.openId =  res.data.wxOpenId
                    orderData.apiType = 'JSAPI'
                    // localStorage.setItem('openId',that.openId)
                    wxPay(orderData).then(res=>{
                      //这个对象用来调起支付接口
                      let tempData = {
                        appId: res.data.appid,
                        timeStamp:res.data.timestamp,
                        nonceStr:res.data.noncestr,
                        package:'prepay_id='+res.data.prepayid,
                        signType: 'MD5',
                        paySign:res.data.sign,
                        key:res.data.key,
                        //另外的参数，用于支付结束后获取订单信息
                        orderNo:orderData.orderNo
                      }
                      _this.rechargeWx(tempData)
                    })
                  })
                }

              }else if(that.isAlipay&&!that.isFree){
                // 支付宝支付
                orderData.orderNo = res.data.orderNo
                orderData.body = res.data.cupType?res.data.cupType.beverage.name:'';
                aliPay(orderData).then(res=>{
                      const div = document.createElement('div');
                      div.innerHTML = res.data;
                      document.body.appendChild(div);
                      document.forms[0].submit();
                  // ap.tradePay({
                  //   orderStr: res.data
                  // }, function(res){
                  //  // ap.alert(res.resultCode);
                  //   if(res.resultCode ==9000){
                  //     var orderFrom = 0;

                  //     //window.location.href = 'https://icloud.lhcoffeetime.com/pages/payment/index.html?orderNo='+orderData.orderNo+'&orderFrom='+orderFrom+'#/alisuccess'
                  //   }
                  // });
                })
              }
            }
          }else{
            alert(res.code)
          }
        })
    },
      // 调起微信支付
    rechargeWx (params) {
      let strTemp = 'appId='+params.appId+'&nonceStr='+params.nonceStr+'&package='+params.package+'&signType='+params.signType+'&timeStamp='+params.timeStamp
      let str = strTemp+'&key='+params.key;
      let sign = md5(str).toUpperCase().substr(0, 32);
      let data = {
        appId: params.appId,
        nonceStr: params.nonceStr,
        package: params.package,
        signType: params.signType,
        timeStamp: params.timeStamp,
        paySign: sign
      }
      jsSDK(data,params.orderNo,1,this.dtuNo);
    },
    getCurrentTime() {
      //获取当前时间并打印
  　　let yy = new Date().getFullYear();
  　　let mm = new Date().getMonth()+1;
  　　let dd = new Date().getDate();
  　　let hh = new Date().getHours();
  　　let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
  　　let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
  　　this.currentTime = yy+'-'+mm+'-'+dd+' '+hh+':'+mf+':'+ss;
    }
  }
}
</script>

<style lang="less">
  #product-detail{
    width: 100vw;
    height: 100vh;
    background-color: #F5F5F5;
    min-width: 320px;
    max-width: 800px;
    margin: auto;
    -webkit-tap-highlight-color: transparent;
    position: relative;
    .main-img{
      width:100%;
      height:40em;
    }
    .img-content{
      background-color: #FFFFFF;
      font-size: 14px;
      text-align: left;
      padding: .6em;
      .img-content-title{
        a{
          background: 0 0;
          color: #000000;
          text-decoration: none;
          display: block;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          margin-bottom: .2em;
        }
      }
      .price{
        margin-top: .3rem;
        font-size: .8em;
        color: #fd4648;
        margin-bottom: 0;
        .ng-binding{
          font-size: 16px;
        }
      }
    }
    .bottom-pay{
      width: 100%;
      height: 3rem;
      background-color: #4169E1;
      line-height: 3rem;
      color: #FFFFFF;
      font-size: 18px;
      bottom: 0;
      position: absolute;
    }
    .bottom-nopay{
      width: 100%;
      height: 7vh;
      background-color: #5f6063;
      line-height: 3rem;
      color: #FFFFFF;
      font-size: 18px;
      bottom: 0;
      position: absolute;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ProductDetail.vue